module.exports = __webpack_public_path__ + "infocentrum13.jpg?441651b4cf206f3999a815bfe8fda97d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum13.jpg
// module id = 265
// module chunks = 0